import moment from "moment";
import React from "react";
import Select from "react-select";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledCollapse,
  Form,
  FormGroup,
  Tooltip,
  CustomInput,
} from "reactstrap";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdArrowUpward,
  MdArrowDownward,
  // MdDeleteForever,
} from "react-icons/md";
import { FaCamera, FaClock, FaCheckCircle } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { IoIosPaper } from "react-icons/io";

import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { GlobalContext } from "../components/Layout/MainLayout";

import * as Server from "../Server";

class RushPlayers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      camp: {},
      Camps: [],
      CampOptions: [],
      selectedCamp: {
        value: "all",
        label: "All",
      },
      CampsUsingTeams: [],
      Teams: [],
      players: [],
      checkTeamFilter: "",
      selectedPlayer: "",
      totalPlayers: 0,
      pageNumbers: [],
      filterCollapse: true,
      showLoader: false,
      selectedTeam: null,
      selectdPlayers: [],
      teamFilter: "unregistered",
      hideRegistered: false,
      removePlayerModal: false,
      birthCertificateTooltip: false,
      profileImageTooltip: false,
      addTeamConfirmationModal: false,
      teamFilterValue: {
        value: "unregistered",
        label: "Players Not Assigned To Team",
      },
      selectedTeamForAPI: {
        value: "all",
        label: "All",
      },
      selectedEventForAPI: {
        value: "all",
        label: "All",
      },
      teamAssignedToPlayers: false,
      csvData: [],
      csvHeaders: [],
      searchPlayerFor: "",
      gender: "",
      year: "",
      globalSearch: "",
      unregisteredPlayersCsvData: [],
      unregisteredPlayersCsvHeaders: [],
      includeArchivedPlayer: false,
      sendNotificationModal: false,
      notificationMessage: "",
    };
    this.sortKey = [];
  }

  componentDidMount() {
    this.setState({ limit: this.context.limit }, () => {
      this.getAllPlayers();
      this.getCamps();
      this.getTeams();
    });
    for (let index = 0; index < 6; index++) {
      this.sortKey.push(true);
    }
  }

  getAllPlayers = async () => {
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "rushsoccer/getAllPlayers",
        method: "POST",
        data: {
          page,
          pageLimit,
          globalSearch: this.state.globalSearch,
          gender: this.state.gender,
          year: this.state.year,
          includeArchivedPlayer: this.state.includeArchivedPlayer,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          pages: response.pages,
          players: response.players,
          totalPlayers: response.totalPlayers,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
      });
      if (response && response.camps.length) {
        let CampOptions = response.camps.map((camp) => ({
          value: camp._id,
          label: camp.name,
        }));
        this.setState({
          showLoader: false,
          Camps: response.camps,
          CampOptions: [
            {
              value: "all",
              label: "All",
            },
            ...CampOptions,
          ],
        });
      } else {
        this.setState({
          showLoader: false,
          Camps: [],
          players: [],
          pages: 0,
          totalPlayers: 0,
          pageNumbers: [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCampsUsingTeams = async (teamId) => {
    try {
      this.setState({ showLoader: true });
      let teamIds =
        teamId && teamId !== "all"
          ? [teamId]
          : this.state.Teams.map((team) => team._id);
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
        params: {
          teamIds: teamIds,
        },
      });
      if (response && response.camps.length) {
        this.setState({
          showLoader: false,
          CampsUsingTeams: response.camps,
        });
      } else {
        this.setState({
          showLoader: false,
          CampsUsingTeams: [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  filterPlayers = async (event) => {
    event.preventDefault();
    this.state.searchPlayerFor
      ? this.state.hideRegistered
        ? this.getUnRegisterdPlayers()
        : this.getPlayers({ _id: this.state.selectedCamp.value })
      : this.getAllPlayers();
  };

  getPlayers = async (event) => {
    if (!event._id) event.preventDefault();
    try {
      let campId = event._id ? event._id : this.state.selectedCamp.value;
      this.setState({
        showLoader: true,
        camp: this.state.Camps.find((camp) => camp._id === campId),
      });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "rushsoccer/player/list",
        method: "POST",
        data: {
          page,
          pageLimit,
          campId,
          globalSearch: this.state.globalSearch,
          gender: this.state.gender,
          year: this.state.year,
          includeArchivedPlayer: this.state.includeArchivedPlayer,
        },
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            pages: response.pages,
            players: response.players,
            totalPlayers: response.totalPlayers,
          },
          () => this.csvData()
        );
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getUnRegisterdPlayers = async (event) => {
    if (event) event.preventDefault();
    try {
      let page = this.state.page;
      let pageLimit = this.state.limit;
      this.setState({ showLoader: true });
      let teamIds =
        this.state.selectedTeamForAPI.value === "all"
          ? this.state.Teams.map((team) => team._id)
          : [this.state.selectedTeamForAPI.value];
      let campIds = [];
      if (this.state.selectedEventForAPI.value === "all") {
        campIds = this.state.CampsUsingTeams.map((camp) => camp._id);
      } else {
        let camp = this.state.CampsUsingTeams.find(
          (camp) => camp._id === this.state.selectedEventForAPI.value
        );
        teamIds =
          this.state.selectedTeamForAPI.value === "all"
            ? camp.teams
            : [this.state.selectedTeamForAPI.value];
        campIds = [this.state.selectedEventForAPI.value];
      }
      let response = await Server.request({
        url: "rushsoccer/player/unregistered",
        method: "POST",
        data: {
          page,
          pageLimit,
          teamIds,
          campIds,
          year: this.state.year,
          globalSearch: this.state.globalSearch,
          teamFilter: this.state.teamFilter,
          gender: this.state.gender,
          includeArchivedPlayer: this.state.includeArchivedPlayer,
        },
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            pages: response.pages,
            players: response.players,
            totalPlayers: response.totalPlayers,
            selectdPlayers: [],
            selectedTeam: null,
            teamAssignedToPlayers:
              this.state.teamFilter === "registered" ? true : false,
            csvData: [],
            csvHeaders: [],
          },
          () => this.csvData()
        );
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({
          pageNumbers: pageNumbers,
          checkTeamFilter:
            this.state.teamFilter === "unregistered" ? "unregistered" : "",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadCSVData = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let teamIds =
        this.state.selectedTeamForAPI.value === "all"
          ? this.state.Teams.map((team) => team._id)
          : [this.state.selectedTeamForAPI.value];
      let campIds = [];
      let campName;
      if (this.state.selectedEventForAPI.value === "all") {
        campIds = this.state.CampsUsingTeams.map((camp) => camp._id);
        campName = this.state.CampsUsingTeams.map((camp) => camp.name).join(
          ","
        );
      } else {
        let camp = this.state.CampsUsingTeams.find(
          (camp) => camp._id === this.state.selectedEventForAPI.value
        );
        campName = this.state.selectedEventForAPI.label;
        teamIds =
          this.state.selectedTeamForAPI.value === "all"
            ? camp.teams
            : [this.state.selectedTeamForAPI.value];
        campIds = [this.state.selectedEventForAPI.value];
      }
      let response = await Server.request({
        url: "rushsoccer/player/unregistered/csvData",
        method: "POST",
        data: {
          teamIds,
          campIds,
          year: this.state.year,
          globalSearch: this.state.globalSearch,
          teamFilter: this.state.teamFilter,
          gender: this.state.gender,
          campName,
          includeArchivedPlayer: this.state.includeArchivedPlayer,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          selectdPlayers: [],
          selectedTeam: null,
          teamAssignedToPlayers:
            this.state.teamFilter === "registered" ? true : false,
          unregisteredPlayersCsvData: response.csvData,
          unregisteredPlayersCsvHeaders: response.csvHeaders,
          checkTeamFilter:
            this.state.teamFilter === "unregistered" ? "unregistered" : "",
        });
        this.csvLink.link.click();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  sendNotification = async () => {
    try {
      if (!this.state.notificationMessage)
        throw Error("Notificaiton message is required");
      this.setState({ showLoader: true });
      let dataObj;
      if (this.state.searchPlayerFor) {
        if (this.state.hideRegistered) {
          let teamIds =
            this.state.selectedTeamForAPI.value === "all"
              ? this.state.Teams.map((team) => team._id)
              : [this.state.selectedTeamForAPI.value];
          let campIds = [];
          let campName;
          if (this.state.selectedEventForAPI.value === "all") {
            campIds = this.state.CampsUsingTeams.map((camp) => camp._id);
            campName = this.state.CampsUsingTeams.map((camp) => camp.name).join(
              ","
            );
          } else {
            let camp = this.state.CampsUsingTeams.find(
              (camp) => camp._id === this.state.selectedEventForAPI.value
            );
            campName = this.state.selectedEventForAPI.label;
            teamIds =
              this.state.selectedTeamForAPI.value === "all"
                ? camp.teams
                : [this.state.selectedTeamForAPI.value];
            campIds = [this.state.selectedEventForAPI.value];
          }
          dataObj = {
            sendNotificationTo: "unregistered",
            teamIds,
            campIds,
            year: this.state.year,
            globalSearch: this.state.globalSearch,
            teamFilter: this.state.teamFilter,
            gender: this.state.gender,
            campName,
            includeArchivedPlayer: this.state.includeArchivedPlayer,
          };
        } else {
          let campId = this.state.selectedCamp.value;
          dataObj = {
            sendNotificationTo: "registered",
            campId,
            globalSearch: this.state.globalSearch,
            gender: this.state.gender,
            year: this.state.year,
            includeArchivedPlayer: this.state.includeArchivedPlayer,
          };
        }
      } else {
        dataObj = {
          sendNotificationTo: "allPlayers",
          globalSearch: this.state.globalSearch,
          gender: this.state.gender,
          year: this.state.year,
          includeArchivedPlayer: this.state.includeArchivedPlayer,
        };
      }
      Object.assign(dataObj, {
        notificationMessage: this.state.notificationMessage,
      });
      let response = await Server.request({
        url: "rushsoccer/player/unregistered/sendNotification",
        method: "POST",
        data: dataObj,
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTeams = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/club/teamlist",
        method: "GET",
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            Teams: response.teams,
          },
          () => this.getCampsUsingTeams()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateTeam = async (event) => {
    event.preventDefault();
    if (!this.state.selectdPlayers.length) {
      this.notificationSystem.addNotification({
        message: "Select atleast one player",
        level: "error",
      });
      return;
    }
    let team = this.state.Teams.find(
      (team) => team._id === this.state.selectedTeam.value
    );
    team.players.push(
      ...this.state.selectdPlayers.map(
        (selectdPlayer) => selectdPlayer.child._id
      )
    );
    team.players = [...new Set(team.players)];
    try {
      let response = await Server.request({
        url: "rushsoccer/team/update",
        method: "POST",
        data: team,
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: "Player added in team successfully",
          level: "success",
        });
        this.toggleAddTeamPlayerConfirmationModal(event);
        this.getUnRegisterdPlayers();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removePlayer = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/player/delete",
        method: "POST",
        data: {
          delete: "child",
          parentId: this.state.selectedPlayer._id,
          childId: this.state.selectedPlayer.child._id,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getUnRegisterdPlayers();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = async (page, limit) => {
    this.setState({ page: Number(page), limit: limit }, () => {
      this.state.searchPlayerFor
        ? this.state.hideRegistered
          ? this.getUnRegisterdPlayers()
          : this.getPlayers({
              _id:
                this.state.camp && this.state.camp._id
                  ? this.state.camp._id
                  : "all",
            })
        : this.getAllPlayers();
    });
  };

  renderPlayerDetailPage = async (childId) => {
    this.props.history.push({
      pathname: "/playerDetail",
      state: { childId },
    });
  };

  toggleRemovePlayerModal = () => {
    this.setState({ removePlayerModal: !this.state.removePlayerModal });
  };

  toggleSendNotificationModal = () => {
    this.setState({
      notificationMessage: "",
      sendNotificationModal: !this.state.sendNotificationModal,
    });
  };

  SortByColumn = (e, key, column, file) => {
    e.preventDefault();
    let Players = [];
    if (
      key === "firstName" ||
      key === "lastName" ||
      key === "birthday" ||
      key === "coachName" ||
      key === "teamName" ||
      key === "event"
    ) {
      if (this.sortKey[column] === true) {
        Players = this.state.players.sort((a, b) => {
          if (a.child.data[key] < b.child.data[key]) return -1;
          if (a.child.data[key] > b.child.data[key]) return 1;
          return 0;
        });
        this.sortKey[column] = false;
      } else {
        Players = this.state.players.sort((a, b) => {
          if (a.child.data[key] > b.child.data[key]) return -1;
          if (a.child.data[key] < b.child.data[key]) return 1;
          return 0;
        });
        this.sortKey[column] = true;
      }
    }
    if (key === "status") {
      if (file === "photo") {
        if (this.sortKey[column] === true) {
          Players = this.state.players.sort((a, b) => {
            if (
              a.child.data.files &&
              a.child.data.files.length &&
              b.child.data.files &&
              b.child.data.files.length
            ) {
              if (a.child.data.files[0].status < b.child.data.files[0].status)
                return -1;
              if (a.child.data.files[0].status > b.child.data.files[0].status)
                return 1;
              return 0;
            } else {
              return 0;
            }
          });
          this.sortKey[column] = false;
        } else {
          Players = this.state.players.sort((a, b) => {
            if (
              a.child.data.files &&
              a.child.data.files.length &&
              b.child.data.files &&
              b.child.data.files.length
            ) {
              if (a.child.data.files[0].status > b.child.data.files[0].status)
                return -1;
              if (a.child.data.files[0].status < b.child.data.files[0].status)
                return 1;
              return 0;
            } else {
              return 0;
            }
          });
          this.sortKey[column] = true;
        }
      }
      if (file === "birthCertificate") {
        if (this.sortKey[column] === true) {
          Players = this.state.players.sort((a, b) => {
            if (
              a.child.data.files &&
              a.child.data.files.length &&
              b.child.data.files &&
              b.child.data.files.length
            ) {
              if (a.child.data.files[1].status < b.child.data.files[1].status)
                return -1;
              if (a.child.data.files[1].status > b.child.data.files[1].status)
                return 1;
              return 0;
            } else {
              return 0;
            }
          });
          this.sortKey[column] = false;
        } else {
          Players = this.state.players.sort((a, b) => {
            if (
              a.child.data.files &&
              a.child.data.files.length &&
              b.child.data.files &&
              b.child.data.files.length
            ) {
              if (a.child.data.files[1].status > b.child.data.files[1].status)
                return -1;
              if (a.child.data.files[1].status < b.child.data.files[1].status)
                return 1;
              return 0;
            } else {
              return 0;
            }
          });
          this.sortKey[column] = true;
        }
      }
    }
    Players.length > 0 && this.setState({ players: Players });
  };

  toggleAddTeamPlayerConfirmationModal = (event) => {
    event.preventDefault();
    this.setState({
      addTeamConfirmationModal: !this.state.addTeamConfirmationModal,
    });
  };

  handleChange = async (user) => {
    if (this.state.selectdPlayers.find((p) => p.child._id === user.child._id)) {
      this.setState({
        selectdPlayers: this.state.selectdPlayers.filter(
          (player) => player.child._id !== user.child._id
        ),
      });
    } else {
      this.state.selectdPlayers.push(user);
    }
    this.forceUpdate();
  };

  selectAll = async () => {
    if (
      this.state.selectdPlayers.length > 0 &&
      this.state.selectdPlayers.length !== this.state.players.length
    ) {
      this.setState({ selectdPlayers: [] });
      await this.state.players.map(
        (player) =>
          !player.child.teamAssigned && this.state.selectdPlayers.push(player)
      );
    }

    if (this.state.selectdPlayers.length > 0) {
      this.setState({ selectdPlayers: [] });
    }
    if (this.state.selectdPlayers.length === 0) {
      await this.state.players.map(
        (player) =>
          !player.child.teamAssigned && this.state.selectdPlayers.push(player)
      );
    }
    this.forceUpdate();
  };

  handleChangeYear = async (date) => {
    if (date instanceof Date) {
      let year = date.getFullYear() || "";
      this.setState({ year });
    } else if (date === null) {
      this.setState({ year: date });
    }
  };

  csvData = () => {
    let csvHeaders = [
      { label: "First Name", key: "firstname" },
      { label: "Last Name", key: "lastname" },
      { label: "Date Of Birth", key: "birthday" },
      { label: "Gender", key: "gender" },
      { label: "Address", key: "address" },
      { label: "State", key: "state" },
      { label: "City", key: "city" },
      { label: "ZipCode", key: "zipcode" },
      { label: "Registration Date", key: "registrationDate" },
      { label: "Coach", key: "coach" },
      { label: "Parent", key: "parentName" },
      { label: "Parent FirstName", key: "parentFirstName" },
      { label: "Parent LastName", key: "parentLastName" },
      { label: "Parent Email", key: "email" },
      { label: "Parent Phone", key: "phone" },
      { label: "Credit Amount", key: "creditAmount" },
      { label: "Due Amount", key: "dueAmount" },
      { label: "Teams", key: "teams" },
      { label: "Registered Events", key: "registeredEvents" },
      { label: "Non-Registered Events", key: "nonRegisteredEvents" },
    ];
    let csvData = this.state.players.map((player) => {
      let event;
      let eventName;
      let registeredEventName;
      let teamNames = [];
      if (this.state.searchPlayerFor) {
        switch (this.state.searchPlayerFor) {
          case "registered":
            eventName = "-";
            teamNames = player.child.teams.map((team) => team.name);
            teamNames = Array.isArray(teamNames)
              ? teamNames.length
                ? teamNames.join(",")
                : "-"
              : "-";
            if (this.state.selectedCamp.value === "all") {
              let campIds = player.child.camps.map((camp) => camp.campId);
              event = this.state.Camps.filter((camp) =>
                campIds.includes(camp._id)
              ).map((camp) => camp.name);
            } else {
              event = this.state.camp;
            }
            registeredEventName = event.name
              ? event.name
              : Array.isArray(event)
              ? event.join(",")
              : "-";
            break;
          case "unregistered":
            registeredEventName = "-";
            if (this.state.selectedEventForAPI.value === "all") {
              let teamIds = player.child.teams.map((team) => team._id);
              event = this.state.CampsUsingTeams.filter((camp) =>
                camp.teams.find((teamId) => teamIds.includes(teamId))
              ).map((camp) => camp.name);
            } else {
              event = this.state.CampsUsingTeams.find(
                (camp) => camp._id === this.state.selectedEventForAPI.value
              );
            }
            eventName = event.name
              ? event.name
              : Array.isArray(event)
              ? event.join(",")
              : "-";
            if (this.state.selectedTeamForAPI.value === "all") {
              teamNames =
                player.child.teams && Array.isArray(player.child.teams)
                  ? player.child.teams.map((team) => team.name)
                  : "-";
              teamNames = Array.isArray(teamNames) ? teamNames.join(",") : "-";
            } else {
              let team = this.state.Teams.find(
                (team) => team._id === this.state.selectedTeamForAPI.value
              );
              teamNames = team ? team.name : "-";
            }
            break;
        }
      } else {
        // teamNames = player.child.teams.map((team) => team.name);
        // teamNames = Array.isArray(teamNames)
        //   ? teamNames.length
        //     ? teamNames.join(",")
        //     : "-"
        //   : "-";
        // let teamIds = player.child.teams.map((team) => team._id);
        // let camps = [];
        // teamIds.map(teamId => {
        //   let campsFound = this.state.Camps.filter(camp => camp.teams.includes(teamId));
        //   camps.push(...campsFound);
        // });
        // if (this.state.selectedCamp.value === "all") {
        //   let campIds = player.child.camps.map((camp) => camp.campId);
        //   event = this.state.Camps.filter((camp) =>
        //     campIds.includes(camp._id)
        //   ).map((camp) => camp.name);
        // } else {
        //   event = this.state.camp;
        // }
        // registeredEventName = event.name
        //   ? event.name
        //   : Array.isArray(event)
        //     ? event.join(",")
        //     : "-";
        // if (this.state.selectedEventForAPI.value === "all") {
        //   let teamIds = player.child.teams.map((team) => team._id);
        //   event = this.state.CampsUsingTeams.filter((camp) =>
        //     camp.teams.find((teamId) => teamIds.includes(teamId))
        //   ).map((camp) => camp.name);
        // } else {
        //   event = this.state.CampsUsingTeams.find(
        //     (camp) => camp._id === this.state.selectedEventForAPI.value
        //   );
        // }
        // eventName = event.name
        //   ? event.name
        //   : Array.isArray(event)
        //     ? event.join(",")
        //     : "-";
      }
      return {
        firstname: player.child.data.firstName || "-",
        lastname: player.child.data.lastName || "-",
        birthday:
          moment.utc(player.child.data.birthday).format("MM/DD/YYYY") || "-",
        gender: player.child.data.gender || "-",
        address: player.child.data.address || "-",
        state: player.child.data.state || "-",
        city: player.child.data.city || "-",
        zipcode: player.child.data.zipcode || "-",
        registrationDate: player.child.createdAt
          ? moment.utc(player.child.createdAt).format("MM/DD/YYYY")
          : "-",
        coach: player.child.data.coachName || "-",
        parentName: player.data.firstName + " " + player.data.lastName,
        parentFirstName: player.data.firstName || "-",
        parentLastName: player.data.lastName || "-",
        email: player.data.email || "-",
        phone: player.data.phone || "-",
        creditAmount: player.child.creditAmount || "0",
        dueAmount: player.child.dueAmount || "0",
        teams: teamNames,
        registeredEvents: registeredEventName,
        nonRegisteredEvents: eventName,
      };
    });
    this.setState({
      csvData,
      csvHeaders,
    });
    this.forceUpdate();
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Players" breadcrumbs={[{ name: "Players", active: true }]}>
          <Row>
            <Col>
              <Card className="mb-3">
                <CardHeader>
                  <Row>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex">
                        <div sm={4} className="mt-2 pr-2">
                          <Label>Shown</Label>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            name="pageLimit"
                            value={this.state.limit}
                            onChange={(event) => {
                              this.refreshPagination(1, event.target.value);
                              this.context.updateState({
                                limit: event.target.value,
                              });
                            }}
                          >
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Input>
                        </div>
                        <div sm={4} className="mt-2 pl-2">
                          <Label>entries</Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-center">
                        <div className="mt-2 pr-2">
                          <Label>
                            Showing{" "}
                            {!this.state.totalPlayers
                              ? 0
                              : this.state.page * this.state.limit -
                                (this.state.limit - 1)}{" "}
                            to{" "}
                            {this.state.page * this.state.limit >
                            this.state.totalPlayers
                              ? this.state.totalPlayers
                              : this.state.page * this.state.limit}{" "}
                            of {this.state.totalPlayers}
                          </Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <div sm={4} className="pr-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page <= 1}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page - 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                          </Button>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            value={this.state.page}
                            name="filter"
                            onChange={(event) => {
                              this.refreshPagination(
                                event.target.value,
                                this.state.limit
                              );
                            }}
                          >
                            {this.state.pageNumbers.length ? (
                              this.state.pageNumbers.map(
                                (pageNumber, index) => (
                                  <option value={pageNumber} key={index}>
                                    {pageNumber}
                                  </option>
                                )
                              )
                            ) : (
                              <option value={0}>0</option>
                            )}
                          </Input>
                        </div>
                        <div sm={4} className="pl-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page >= this.state.pages}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page + 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <Button
                          color="primary"
                          id="toggler2"
                          style={{
                            float: "right",
                            marginBottom: "10px",
                            width: "25%",
                          }}
                          onClick={() => {
                            this.setState({
                              isOpen: false,
                              filterCollapse: !this.state.filterCollapse,
                            });
                          }}
                        >
                          Filters
                        </Button>
                      </div>
                      <UncontrolledCollapse
                        toggler="#toggler2"
                        isOpen={this.state.filterCollapse}
                      >
                        <Card>
                          <CardBody>
                            <Form
                              className="form"
                              onSubmit={(event) => this.filterPlayers(event)}
                            >
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label>Search</Label>
                                    <Input
                                      icon="search"
                                      value={this.state.globalSearch}
                                      placeholder="Search"
                                      onChange={(event) =>
                                        this.setState({
                                          globalSearch: event.target.value,
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <CustomInput
                                      type="checkbox"
                                      id="checkbox1"
                                      label="Include Archived Players"
                                      checked={this.state.includeArchivedPlayer}
                                      onChange={() =>
                                        this.setState({
                                          includeArchivedPlayer: !this.state
                                            .includeArchivedPlayer,
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <Label>Gender</Label>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <Row>
                                    <Col sm={3}>
                                      <FormGroup>
                                        <CustomInput
                                          type="radio"
                                          name="male"
                                          id="male"
                                          value="male"
                                          label="Male"
                                          onClick={(event) =>
                                            this.setState({
                                              gender: event.target.value,
                                            })
                                          }
                                          checked={
                                            this.state.gender === "male" && true
                                          }
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                      <FormGroup>
                                        <CustomInput
                                          type="radio"
                                          name="female"
                                          id="female"
                                          value="female"
                                          label="Female"
                                          onClick={(event) =>
                                            this.setState({
                                              gender: event.target.value,
                                            })
                                          }
                                          checked={
                                            this.state.gender === "female" &&
                                            true
                                          }
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label for="name">
                                      Search By Players Birth Year
                                    </Label>
                                    <DatePicker
                                      selected={
                                        this.state.year &&
                                        new Date().setFullYear(
                                          Number(this.state.year)
                                        )
                                      }
                                      onChange={(date) =>
                                        this.handleChangeYear(date)
                                      }
                                      showYearPicker
                                      dateFormat="yyyy"
                                      style={{ width: "50% !important" }}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <Row>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <CustomInput
                                          type="radio"
                                          name="registered"
                                          id="registered"
                                          value="registered"
                                          label="Registered For Events"
                                          onClick={(event) =>
                                            this.setState({
                                              hideRegistered: false,
                                              searchPlayerFor:
                                                event.target.value,
                                            })
                                          }
                                          checked={
                                            this.state.searchPlayerFor ===
                                            "registered"
                                          }
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <CustomInput
                                          type="radio"
                                          name="unregistered"
                                          id="unregistered"
                                          value="unregistered"
                                          label="Not Registered For Events"
                                          onClick={(event) =>
                                            this.setState({
                                              hideRegistered: true,
                                              searchPlayerFor:
                                                event.target.value,
                                            })
                                          }
                                          checked={
                                            this.state.searchPlayerFor ===
                                            "unregistered"
                                          }
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              {this.state.searchPlayerFor ? (
                                this.state.hideRegistered ? (
                                  <>
                                    <Row>
                                      <Col xl={12} lg={12} md={12}>
                                        <Label>Teams Filter:</Label>
                                        <div>
                                          <Select
                                            isSearchable={false}
                                            className="mb-2 width50"
                                            value={this.state.teamFilterValue}
                                            options={[
                                              {
                                                value: "registered",
                                                label:
                                                  "Players Assigned To Team",
                                              },
                                              {
                                                value: "unregistered",
                                                label:
                                                  "Players Not Assigned To Team",
                                              },
                                            ]}
                                            onChange={(result) =>
                                              this.setState({
                                                teamFilterValue: result,
                                                teamFilter: result.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                    {this.state.teamAssignedToPlayers ? (
                                      <>
                                        <Row>
                                          <Col xl={12} lg={12} md={12}>
                                            <Label>Select Team :</Label>
                                            <Select
                                              className="mb-2 width50"
                                              value={
                                                this.state.selectedTeamForAPI
                                              }
                                              options={[
                                                {
                                                  value: "all",
                                                  label: "All",
                                                },
                                                ...this.state.Teams.map(
                                                  (team) => ({
                                                    value: team._id,
                                                    label: team.name,
                                                  })
                                                ),
                                              ]}
                                              onChange={(result) => {
                                                this.setState(
                                                  {
                                                    selectedTeamForAPI: result,
                                                    selectedEventForAPI: {
                                                      value: "all",
                                                      label: "All",
                                                    },
                                                  },
                                                  () =>
                                                    this.getCampsUsingTeams(
                                                      result.value
                                                    )
                                                );
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col xl={12} lg={12} md={12}>
                                            <Label>Select Event :</Label>
                                            <Select
                                              className="mb-2 width50"
                                              value={
                                                this.state.selectedEventForAPI
                                              }
                                              options={[
                                                {
                                                  value: "all",
                                                  label: "All",
                                                },
                                                ...this.state.CampsUsingTeams.map(
                                                  (camp) => ({
                                                    value: camp._id,
                                                    label: camp.name,
                                                  })
                                                ),
                                              ]}
                                              onChange={(result) =>
                                                this.setState({
                                                  selectedEventForAPI: result,
                                                })
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <Row>
                                    <Col xl={12} lg={12} md={12}>
                                      <FormGroup>
                                        <Label>Events:</Label>

                                        <Select
                                          className="mb-2 width50"
                                          value={this.state.selectedCamp}
                                          options={this.state.CampOptions}
                                          onChange={(result) => {
                                            let camp = this.state.Camps.find(
                                              (camp) =>
                                                camp._id === result.value
                                            );
                                            this.setState({
                                              camp,
                                              selectedCamp: result,
                                            });
                                          }}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )
                              ) : null}
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Button
                                      className="mr-3"
                                      color="primary"
                                      type="submit"
                                    >
                                      Filter
                                    </Button>
                                    <Button
                                      onClick={() =>
                                        this.setState({
                                          searchPlayerFor: "",
                                          globalSearch: "",
                                          gender: "",
                                          year: "",
                                          teamFilter: "unregistered",
                                          teamFilterValue: {
                                            value: "unregistered",
                                            label:
                                              "Players Not Assigned To Team",
                                          },
                                          selectedTeamForAPI: {
                                            value: "all",
                                            label: "All",
                                          },
                                          selectedEventForAPI: {
                                            value: "all",
                                            label: "All",
                                          },
                                          selectedCamp: {
                                            value: "all",
                                            label: "All",
                                          },
                                          camp: {},
                                          teamAssignedToPlayers: false,
                                          hideRegistered: false,
                                          includeArchivedPlayer: false,
                                        })
                                      }
                                    >
                                      Reset Filter
                                    </Button>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                          </CardBody>
                        </Card>
                      </UncontrolledCollapse>
                    </Col>

                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "flex-end",
                        marginTop: 10,
                        marginRight: "15px",
                      }}
                    >
                      <Button
                        className="mb-3"
                        style={{ marginRight: 10 }}
                        onClick={() => this.toggleSendNotificationModal()}
                      >
                        Send Notification
                      </Button>
                      {this.state.hideRegistered ? (
                        this.state.teamAssignedToPlayers ? (
                          <>
                            <Button
                              className="mb-3"
                              style={{ marginRight: 10 }}
                              onClick={(event) => this.downloadCSVData(event)}
                            >
                              Download all players
                            </Button>
                            <CSVLink
                              style={{ textDecoration: "unset" }}
                              filename={`players.csv`}
                              data={this.state.unregisteredPlayersCsvData}
                              headers={this.state.unregisteredPlayersCsvHeaders}
                              ref={(ref) => {
                                this.csvLink = ref;
                              }}
                            ></CSVLink>
                          </>
                        ) : (
                          <>
                            <Button
                              onClick={this.selectAll}
                              className="mb-3"
                              style={{ marginRight: 10 }}
                            >
                              Select All
                            </Button>
                            <Button
                              onClick={
                                this.toggleAddTeamPlayerConfirmationModal
                              }
                              className="mb-3"
                            >
                              Add To Team
                            </Button>
                          </>
                        )
                      ) : this.state.searchPlayerFor ? (
                        <>
                          <Button className="mb-3" style={{ marginRight: 10 }}>
                            <CSVLink
                              className="text-white"
                              style={{ textDecoration: "unset" }}
                              filename={`players.csv`}
                              data={this.state.csvData}
                              headers={this.state.csvHeaders}
                            >
                              Download csv
                            </CSVLink>
                          </Button>
                        </>
                      ) : null}
                    </div>
                  </Row>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th className={"text-center"}>
                          <div className="d-flex">
                            <Label>First Name</Label>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "firstName", 0)
                              }
                              className="float-right "
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[0] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th className={"text-center"}>
                          <div className="d-flex">
                            <Label>Last Name</Label>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "lastName", 1)
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[1] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th>
                          <div className="d-flex">
                            <Label> Date of Birth</Label>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "birthday", 2)
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[2] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th className={"text-center"}>
                          <div className="d-flex">
                            <Label>Coach Name</Label>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "coachName", 3)
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[3] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th className={"text-center"}>
                          <div className="d-flex">
                            <Label>Program</Label>
                            <Label
                              onClick={(e) => this.SortByColumn(e, "event", 4)}
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[4] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th className={"text-center"}>
                          <div className="d-flex">
                            <Label>Team Name</Label>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "teamName", 5)
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[5] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th>
                          <div className="d-flex">
                            <FaCamera
                              size="20px"
                              id="TooltipExample"
                              onMouseOver={() =>
                                this.setState({ profileImageTooltip: true })
                              }
                              onMouseOut={() =>
                                this.setState({ profileImageTooltip: false })
                              }
                            />
                            <Tooltip
                              placement="bottom"
                              isOpen={this.state.profileImageTooltip}
                              target="TooltipExample"
                              toggle={() => {}}
                            >
                              Profile Image
                            </Tooltip>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(e, "status", 6, "photo")
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[6] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        <th>
                          <div className="d-flex">
                            <IoIosPaper
                              size="20px"
                              id="TooltipExample1"
                              onMouseOver={() =>
                                this.setState({
                                  birthCertificateTooltip: true,
                                })
                              }
                              onMouseOut={() =>
                                this.setState({
                                  birthCertificateTooltip: false,
                                })
                              }
                            />
                            <Tooltip
                              placement="bottom"
                              isOpen={this.state.birthCertificateTooltip}
                              target="TooltipExample1"
                              toggle={() => {}}
                            >
                              Birth Certificate
                            </Tooltip>
                            <Label
                              onClick={(e) =>
                                this.SortByColumn(
                                  e,
                                  "status",
                                  7,
                                  "birthCertificate"
                                )
                              }
                              className="float-right"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {this.sortKey[7] === true ? (
                                <MdArrowUpward size="20px" />
                              ) : (
                                <MdArrowDownward size="20px" />
                              )}
                            </Label>
                          </div>
                        </th>
                        {/* <th
                          hidden={
                            this.state.checkTeamFilter === "unregistered" &&
                            this.state.hideRegistered === true
                              ? false
                              : true
                          }
                        >
                          Delete Player
                        </th> */}
                        <th hidden={!this.state.hideRegistered}>
                          <Label>Select Players</Label>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.players && this.state.players.length > 0 ? (
                        this.state.players.map((player, index) => (
                          <tr
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.renderPlayerDetailPage(player.child._id)
                            }
                          >
                            <td>
                              {capitalizeFirstLetter(
                                player.child.data.firstName || " "
                              )}
                            </td>
                            <td>
                              {capitalizeFirstLetter(
                                player.child.data.lastName || " "
                              )}
                            </td>
                            <td>
                              {player.child.data.birthday
                                ? moment
                                    .utc(player.child.data.birthday)
                                    .format("MM-DD-YYYY")
                                : "-"}
                            </td>
                            <td>{player.child.data.coachName || "-"}</td>
                            <td>{player.child.data.event || "-"}</td>
                            <td>
                              {(player.child.teams &&
                                player.child.teams.length &&
                                player.child.teams.map((team, index) => (
                                  <div key={index}>
                                    {team.name}
                                    {player.child.teams.length !== index + 1 &&
                                      ","}
                                  </div>
                                ))) ||
                                "-"}
                            </td>
                            <td>
                              {player.child.data.files.map((file) =>
                                file.name === "photo" ? (
                                  file.status === "pending" ? (
                                    <FaClock size="20px" />
                                  ) : file.status === "accepted" ? (
                                    <FaCheckCircle size="20px" color="green" />
                                  ) : file.status === "rejected" ? (
                                    <FcCancel size="25px" />
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )
                              )}
                            </td>
                            <td>
                              {player.child.data.files.map((file) =>
                                file.name === "birthCertificate" ? (
                                  file.status === "pending" ? (
                                    <FaClock size="20px" />
                                  ) : file.status === "accepted" ? (
                                    <FaCheckCircle size="20px" color="green" />
                                  ) : file.status === "rejected" ? (
                                    <FcCancel size="25px" />
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )
                              )}
                            </td>
                            {/* <td
                              hidden={
                                this.state.checkTeamFilter === "unregistered" &&
                                this.state.hideRegistered === true
                                  ? false
                                  : true
                              }
                            >
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.setState({ selectedPlayer: player });
                                  this.toggleRemovePlayerModal();
                                }}
                                className="p-2"
                              >
                                <MdDeleteForever size="25px"></MdDeleteForever>
                              </Button>
                            </td> */}
                            <td hidden={!this.state.hideRegistered}>
                              {player.child.teamAssigned === false ? (
                                <Label className="ml-4 pb-3 text-center">
                                  <Input
                                    type="checkbox"
                                    style={{ width: "20px", height: "30px" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.handleChange(player);
                                    }}
                                    checked={this.state.selectdPlayers.find(
                                      (selectdPlayer) =>
                                        player.child._id ===
                                        selectdPlayer.child._id
                                    )}
                                  ></Input>
                                </Label>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No players found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
                {this.state.addTeamConfirmationModal ? (
                  <Modal
                    isOpen={this.state.addTeamConfirmationModal}
                    toggle={(event) =>
                      this.toggleAddTeamPlayerConfirmationModal(event)
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleAddTeamPlayerConfirmationModal(event)
                      }
                    >
                      <Label>Add To Team :</Label>
                    </ModalHeader>
                    <ModalBody>
                      {
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <Label>Select Team :</Label>
                            <Select
                              value={this.state.selectedTeam}
                              options={this.state.Teams.map((team) => ({
                                value: team._id,
                                label: team.name,
                              }))}
                              onChange={(result) =>
                                this.setState({
                                  selectedTeam: result,
                                })
                              }
                            />
                          </Col>
                        </Row>
                      }
                    </ModalBody>
                    <ModalFooter>
                      <Button onClick={(event) => this.updateTeam(event)}>
                        Add
                      </Button>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleAddTeamPlayerConfirmationModal(event)
                        }
                      >
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.removePlayerModal ? (
                  <Modal
                    isOpen={this.state.removePlayerModal}
                    toggle={(event) => this.toggleRemovePlayerModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleRemovePlayerModal()}
                    ></ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete{" "}
                      {this.state.selectedPlayer.child.data.firstName +
                        " " +
                        this.state.selectedPlayer.child.data.lastName}{" "}
                      ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleRemovePlayerModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.removePlayer();
                          this.toggleRemovePlayerModal();
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.sendNotificationModal ? (
                  <Modal
                    isOpen={this.state.sendNotificationModal}
                    toggle={(event) => this.toggleSendNotificationModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleSendNotificationModal()}
                    >
                      Notification Message
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Notification Message</Label>
                            <Input
                              required
                              type="text"
                              placeholder="Add Notification Message"
                              value={this.state.notificationMessage}
                              onChange={(event) =>
                                this.setState({
                                  notificationMessage: event.target.value,
                                })
                              }
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleSendNotificationModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => {
                          this.sendNotification();
                          this.toggleSendNotificationModal();
                        }}
                      >
                        Send
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
RushPlayers.contextType = GlobalContext;
export default RushPlayers;
